module.exports = "<span>{{$ctrl.text}}</span> <i class=\"td-icon icon-ui-cross close-button\" ng-click=$ctrl.remove()></i> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/closeable-pill/closeable-pill.html
// module id = 610
// module chunks = 0